import { render } from "./CompetitionView.vue?vue&type=template&id=f011d28a&scoped=true"
import script from "./CompetitionView.vue?vue&type=script&lang=js"
export * from "./CompetitionView.vue?vue&type=script&lang=js"

import "./CompetitionView.vue?vue&type=style&index=0&id=f011d28a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f011d28a"]])

export default __exports__